/**
 * @generated SignedSource<<90b77166c7728825a42128815fd11158>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type notificationPreferencesOptionsWrapper_personalSettingsPreferenceFields_NotificationPreferencesOptions$data = {
  readonly isEmailNotificationEnabled: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"assigneeRole_personalSettingsPreferenceFields_NotifyWhenRoleIsAssignee" | "emailEnabled_personalSettingsPreferenceFields_EmailEnabledPreferenceField" | "groupNotificationEmailsWrapper_personalSettingsPreferenceFields" | "mimeType_personalSettingsPreferenceFields_MimeTypePreferenceField" | "notifyOwnChanges_personalSettingsPreferenceFields_NotifyOwnChangesPreferenceField" | "reporterRole_personalSettingsPreferenceFields_NotifyWhenRoleIsReporter">;
  readonly " $fragmentType": "notificationPreferencesOptionsWrapper_personalSettingsPreferenceFields_NotificationPreferencesOptions";
};
export type notificationPreferencesOptionsWrapper_personalSettingsPreferenceFields_NotificationPreferencesOptions$key = {
  readonly " $data"?: notificationPreferencesOptionsWrapper_personalSettingsPreferenceFields_NotificationPreferencesOptions$data;
  readonly " $fragmentSpreads": FragmentRefs<"notificationPreferencesOptionsWrapper_personalSettingsPreferenceFields_NotificationPreferencesOptions">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "notificationPreferencesOptionsWrapper_personalSettingsPreferenceFields_NotificationPreferencesOptions",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEmailNotificationEnabled"
    },
    {
      "kind": "FragmentSpread",
      "name": "emailEnabled_personalSettingsPreferenceFields_EmailEnabledPreferenceField"
    },
    {
      "kind": "FragmentSpread",
      "name": "assigneeRole_personalSettingsPreferenceFields_NotifyWhenRoleIsAssignee"
    },
    {
      "kind": "FragmentSpread",
      "name": "reporterRole_personalSettingsPreferenceFields_NotifyWhenRoleIsReporter"
    },
    {
      "kind": "FragmentSpread",
      "name": "notifyOwnChanges_personalSettingsPreferenceFields_NotifyOwnChangesPreferenceField"
    },
    {
      "kind": "FragmentSpread",
      "name": "groupNotificationEmailsWrapper_personalSettingsPreferenceFields"
    },
    {
      "kind": "FragmentSpread",
      "name": "mimeType_personalSettingsPreferenceFields_MimeTypePreferenceField"
    }
  ],
  "type": "JiraNotificationOptions"
};

(node as any).hash = "ef652be75b6f5f833184a5938356d9dc";

export default node;
